exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.row-pointer[data-v-65b5e1c2] tbody tr :hover {\n  cursor: pointer;\n}\n", ""]);

// exports
